import type {PullItem} from '../types/list-types'

const KNOWN_AGENT_LOGINS = new Set([
  'copilot',
  'copilot-swe-agent',
  'copilot[bot]',
  'copilot-swe-agent[bot]',
  'github-copilot[bot]',
])

function isKnownAgentLogin(login: string): boolean {
  return KNOWN_AGENT_LOGINS.has(login.toLowerCase())
}

export function isAgentAuthor(pull: PullItem): boolean {
  return pull.author.isAgent ?? isKnownAgentLogin(pull.author.displayLogin)
}

export function deriveAttributedUsername(pull: PullItem): string | undefined {
  if (!isAgentAuthor(pull)) return undefined
  // Fallback: single non-agent assignee when explicit attribution is missing
  const nonAgentAssignees = pull.assignees?.filter(
    assignee =>
      assignee.login.toLowerCase() !== pull.author.displayLogin.toLowerCase() && !isKnownAgentLogin(assignee.login),
  )
  const derived = nonAgentAssignees?.length === 1 ? nonAgentAssignees[0]?.login : undefined

  const agentDisplayLogin = pull.agentAttributedUser?.displayLogin || undefined
  const candidate = agentDisplayLogin ?? pull.attributedUsername ?? derived
  if (!candidate) return undefined
  if (candidate.toLowerCase() === pull.author.displayLogin.toLowerCase()) return undefined
  return candidate
}
